/* global google */
import DropDownControl from './DropDownControl.js'
import GroundOverlayCreator from './GroundoverlayCreator.js'
import IndoorFloorSwitchControl from './IndoorFloorSwitchControl.js'

export default class Indoormap{
    constructor(mapDiv,map,indoorMapsData,urlIndoorMapsPrefix, setMapsVisible, eventID,markers){
        this._map=map;
        this._mapDiv=mapDiv;
        this._eventID=eventID;
        this._loadedIndoorMaps = null;
        this._visibleGroundOverlays = [];
        // this._currentFloorLevel = 0;
        this._markers=markers;

        this._setMapsVisible=setMapsVisible;
        this._loadMapsOnStart=true;

        this._indoorMapsControl = new DropDownControl(this._mapDiv);
        this._dropDOwnWrapperId = "myddOptsDiv";
        this._loadingMaskID = "indoorLoadingMask";
        this._loadingHTML = "loading...";
        this.loadingErrorHTML = "...error...";
        this._indoorFloorSwitcherID = "indoorFloorSwitcher";
        this._urlIndoorMapsPrefix=urlIndoorMapsPrefix;
        this._indoorMapsData=indoorMapsData;
        this._dropDownItems = [];

        this._mapsInitialized=false;

        this._centeredIndoorMap = false;

    }

    showIndoorFloorControl(){
        if(this._centeredIndoorMap){
            let centeredIndoorMapData = this._dropDownItems.find(dropDownItem => dropDownItem[1].id_indoormap === this._centeredIndoorMap);
            if(centeredIndoorMapData){
                let boundsArray = centeredIndoorMapData[1].indoorFloorsBounds;
                if (boundsArray.length>1 && this.isCenterInBounds(boundsArray)) {
                    // If the last centered indoor map is still centered, there is nothing to do.
                    this.showIndoorFloorSwitcher(true);
                    return true;
                }
            }
        }
        for (let dropDownItem of this._dropDownItems) {
            let item = dropDownItem[1];
            if (item.indoorFloorsBounds && item.indoorFloorsBounds.length > 1) {
                // Check if center of visible map is within boundsArray
                if (this.isCenterInBounds(item.indoorFloorsBounds)) {
                    item.action(item, true);
                    this._centeredIndoorMap = item.id_indoormap;
                    this.showIndoorFloorSwitcher(true);
                    return true;
                }
            }
        }
        this._centeredIndoorMap = false;
        this.showIndoorFloorSwitcher(false);
        return false;
    }


    getElementById(id){
        let el=document.querySelectorAll('#'+this._mapDiv+' #'+id);
        return (el.length>0)?el[0]:null;
    }

    getElementsByClass(className){
        let el=document.querySelectorAll('#'+this._mapDiv+' .'+className);
        return el;
    }

    init(){

        var loadingMask = this._indoorMapsControl.loadingMask(this._loadingMaskID, this._loadingHTML);

        //put them all together to create the drop down       
        var ddDivOptions = {
            items: [loadingMask],
            id: this._dropDOwnWrapperId
        };
    
        var dropDownDiv = this._indoorMapsControl.dropDownOptionsDiv(ddDivOptions);
    
        var dropDownOptions = {
            gmap: this._map,
            name: 'Indoor Maps',
            id: 'ddControl',
            title: '',
            position: google.maps.ControlPosition.TOP_RIGHT,
            dropDown: dropDownDiv
        };
    
        if(this._setMapsVisible){
            this.initIndoormaps();
            this._map.addListener('center_changed', this.showIndoorFloorControl.bind(this, this));

        }
        let isHidden=true;
        this._indoorMapsControl.initDropDownControl(dropDownOptions, this._dropDOwnWrapperId, ()=>{
            this.initIndoormaps();
        }, this._setMapsVisible, isHidden);
    }

    initIndoormaps(){
        //if(!this._mapsInitialized){
            this.getIndoorMaps(this._setMapsVisible); 
            this._mapsInitialized=true;
        //}
    }


    enableIndoorFloorSwitcher(initFloorCaption, upClb, downClb) {
        var controlDiv = this.getElementById(this._indoorFloorSwitcherID);

        /** Check if control exists */
        if (controlDiv) {
            controlDiv.parentNode.removeChild(controlDiv);
        }

        // Create the DIV to hold the control and
        // call the HomeControl() constructor passing
        // in this DIV.
        controlDiv = document.createElement('div');
        var control = new IndoorFloorSwitchControl(controlDiv, this._map, initFloorCaption, upClb, downClb);
        controlDiv.id = this._indoorFloorSwitcherID;
        control.index = 1;
        this._map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(controlDiv);
    }

    showIndoorFloorSwitcher(show) {
        var switcher = this.getElementById(this._indoorFloorSwitcherID);
        if (null !== switcher && typeof (switcher) !== "undefined") {
            show ? switcher.style.display = 'block' : switcher.style.display = 'none';
        }
    }

    saveGroundOverlay(groundOverlay, mapKey, floorKey) {
        if (typeof (this._visibleGroundOverlays[mapKey]) === "undefined") {
            this._visibleGroundOverlays[mapKey] = [];
        }
        this._visibleGroundOverlays[mapKey][floorKey] = groundOverlay;
    }

    drawGroundOverlay (selectedMapKey, selectedFloorKey, mapObj) {

        var markers = [];

        if (typeof (mapObj) === "undefined" || null === mapObj) {
            console.warn("Can not draw GroundOverlay. mapObj is null.");
            return null;
        }

        if (null === mapObj.lat1 || null === mapObj.lng1 || null === mapObj.lat2 || null === mapObj.lng2) {
            console.warn("Can not draw GroundOverlay. Some Position is null.");
            return null;
        }

        markers.push(new google.maps.Marker({
            position: new google.maps.LatLng(mapObj.lat2, mapObj.lng2),
            map: null
        }));
        markers.push(new google.maps.Marker({
            position: new google.maps.LatLng(mapObj.lat1, mapObj.lng1),
            map: null
        }));
        return new GroundOverlayCreator(markers, process.env.VUE_APP_BASE_URL+this._urlIndoorMapsPrefix + mapObj.file, this._map, mapObj.opacity, mapObj.rotation);
    }

    addAllFloorsAsGroundOverlay(selectedMapKey, indoorFloors) {
        if (null !== indoorFloors && typeof (indoorFloors) !== "undefined") {
            var key = null;
            /** Draw base maps*/
            for (key in indoorFloors) {
                if (indoorFloors[key].explode) {
                    this.addGroundOverlay(selectedMapKey, key, indoorFloors);
                }
            }

            /** Draw building*/
            for (key in indoorFloors) {
                if (!indoorFloors[key].explode) {
                    this.addGroundOverlay(selectedMapKey, key, indoorFloors);
                }
            }
        }
    }
    addGroundOverlay(selectedMapKey, selectedFloorKey, indoorFloors) {
        if (null !== indoorFloors && typeof (indoorFloors) !== "undefined") {
            if (typeof (indoorFloors[selectedFloorKey]) === "object") {
                if(this._visibleGroundOverlays && this._visibleGroundOverlays[selectedMapKey] && this._visibleGroundOverlays[selectedMapKey][selectedFloorKey]){
                    this._visibleGroundOverlays[selectedMapKey][selectedFloorKey].setMap(this._map);
                }else{
                    var go = this.drawGroundOverlay(selectedMapKey, selectedFloorKey, indoorFloors[selectedFloorKey]);
                    this.saveGroundOverlay(go, selectedMapKey, selectedFloorKey);
                }
                return true;
            }

            //alternativ: 

        }
        return false;
    }

    removeAllFloorGroundOverlays(selectedMapKey, indoorFloors) {
        if (null !== indoorFloors) {
            if (null !== indoorFloors && typeof (indoorFloors) !== "undefined") {
                for (var key in indoorFloors) {
                    this.removeGroundOverlay(selectedMapKey, key);
                }
            }
        }
    }

    removeGroundOverlay(mapKey, floorKey) {
        if (null !== this._visibleGroundOverlays
                && null !== this._visibleGroundOverlays[mapKey]
                && typeof (this._visibleGroundOverlays[mapKey]) !== "undefined"
                && null !== this._visibleGroundOverlays[mapKey][floorKey]
                && typeof (this._visibleGroundOverlays[mapKey][floorKey]) !== "undefined") {
                    this._visibleGroundOverlays[mapKey][floorKey].setMap(null);
                    //this._visibleGroundOverlays[mapKey][floorKey] = null;
        }
    }

    removeIndoorMaps() {

        //Remove maps
        if (null != this._visibleGroundOverlays) {
            for (var mapKey in this._visibleGroundOverlays) {
                var indoorMap = this._visibleGroundOverlays[mapKey];
                if (null != indoorMap) {
                    for (var floorKey in indoorMap) {
                        if (null != indoorMap[floorKey]) {
                            indoorMap[floorKey].setMap(null);
                            indoorMap[floorKey] = null;
                        }
                    }
                }
            }
        }

        //Remove Drop down
    }

    isIndoorSwitcherNeeded(loadedIndoorMaps) {
        if (null !== loadedIndoorMaps) {
            for (var key in loadedIndoorMaps) {
                if (!loadedIndoorMaps[key]["indoorMap"].explode) {
                    return true;
                }
            }
        }
        return false;
    }

    changeIndoorFloor(currentMap, selectedMapKey, currentFloorLevel, indoorFloors, newFloorLevel) {

        var res = this.addGroundOverlay(selectedMapKey, newFloorLevel, indoorFloors);
        if (res) {
            this.removeGroundOverlay(selectedMapKey, currentFloorLevel);
            this._filterWaypointsByIndoorFloorId(newFloorLevel, indoorFloors, currentMap);
            this.getElementById('mapIndoorFloorSwitch_input').innerHTML = indoorFloors[newFloorLevel].floor_name;
        }

        return res;
    }

    _filterWaypointsByIndoorFloorId(floorIdInternal, floors, currentMap) {

        var currentFloorId = floors[floorIdInternal].floor_id;
        this.setWaypointsVisibilityOfIndoorMap(currentMap, true, currentFloorId);
    }

    setWaypointsVisibilityOfIndoorMap(currentMap, visible, activeFloorId) {

        if (typeof (this._markers) != "undefined" && null != this._markers) {
            var floorIdsOfMap = this.getFloorIdsOfIndoorMap(currentMap);

            for (var i = 0; i < this._markers.length; i++) {
                var marker = this._markers[i];
                if (typeof (marker) != "undefined" && null != marker) {
                    if (typeof (marker.indoor_floor) != "undefined" && null != marker.indoor_floor && (floorIdsOfMap.indexOf(parseInt(marker.indoor_floor)) > -1)) {

                        if (typeof (activeFloorId) != "undefined" && null != activeFloorId) {
                            if (activeFloorId == marker.indoor_floor) {
                                marker.setVisible(visible);
                            } else {
                                marker.setVisible(!visible);
                            }
                        } else {
                            marker.setVisible(visible);
                        }
                    }
                }
            }
        }
    }

    getFloorIdsOfIndoorMap(currentIndoorMap) {
        var res = [];
        if (typeof (currentIndoorMap) != "undefined" && null != currentIndoorMap) {
            if (typeof (currentIndoorMap["indoorFloors"]) != "undefined" && null != currentIndoorMap["indoorFloors"]) {
                for (var key in currentIndoorMap["indoorFloors"]) {
                    if (typeof (currentIndoorMap["indoorFloors"][key]) != "undefined" && null != currentIndoorMap["indoorFloors"][key]) {
                        res.push(currentIndoorMap["indoorFloors"][key].floor_id)
                    }
                }

            }
        }
        return res;
    }

    increaseIndoorFloor(currentMap, selectedMapKey, indoorFloors, options) {
        if (this.changeIndoorFloor(currentMap, selectedMapKey, options.currentFloorLevel, indoorFloors, options.currentFloorLevel + 1)) {
            options.currentFloorLevel++;
        }
    }

    decreaseIndoorFloor(currentMap, selectedMapKey, indoorFloors, options) {
        if (this.changeIndoorFloor(currentMap, selectedMapKey, options.currentFloorLevel, indoorFloors, options.currentFloorLevel - 1)) {
            options.currentFloorLevel--;
        }
    }

    getHtmlDropDownItems(dropDownItems) {
        var res = [];
        if (typeof (dropDownItems) === "object") {
            for (var k in dropDownItems) {
                if (typeof (dropDownItems[k]) === "object") {
                    res.push(dropDownItems[k][0]);
                }
            }
        }
        return res;
    }

    /** Parse server data and add dropDown items */
    getDropDownItems(data, checked) {
        var items = [];
        var indoorMap = null;
        var context=this;
        for (var key in data) {
            indoorMap = data[key]["indoorMap"];
            let indoorFloorsBounds = data[key].indoorFloors.map(floor => {
                return {
                    lat1: floor.lat1,
                    lng1: floor.lng1,
                    lat2: floor.lat2,
                    lng2: floor.lng2
                };
            });
            var checkOptions = {
                id_indoormap: indoorMap.id_indoormap,
                indoorFloorsBounds: indoorFloorsBounds,
                currentFloorLevel: 0,
                context:context,
                gmap: this._map,
                title: indoorMap["comment"],
                id: ("indoorMap_" + key),
                key: key,
                label: indoorMap["name"],
                explode: indoorMap["explode"],
                checked: checked,
                action: (options, selected)=> {

                    //TODO:evtl wird this hier nicht funltionieren

                    if (null !== context._loadedIndoorMaps && null !== options) {

                        // if (selected) {
                        //     options.currentFloorLevel = 0;
                        // }

                        var indoorMapWrapper = context._loadedIndoorMaps[options.key];
                        var indoorFloors = indoorMapWrapper["indoorFloors"];
                        //this indoorMap=indoorMapWrapper["indoorMap"];

                        if (typeof (indoorFloors) !== "object" || indoorFloors.length < 1) {
                            return;
                        }

                        /** Show all groundoverlays*/
                        if (options.explode) {
                            if (selected) {
                                context.addAllFloorsAsGroundOverlay(options.key, indoorFloors);
                            } else {
                                context.removeAllFloorGroundOverlays(options.key, indoorFloors);
                            }
                        } else {
                            /** Show switcher */
                            if (selected) {
                                context.addGroundOverlay(options.key, options.currentFloorLevel, indoorFloors);
                            } else {
                                context.removeGroundOverlay(options.key, options.currentFloorLevel);
                            }
                        }

                        if (selected) {
                            var currentFloorId = indoorFloors[options.currentFloorLevel].floor_id;
                            context.setWaypointsVisibilityOfIndoorMap(indoorMapWrapper, true, currentFloorId);
                        } else {
                            context.setWaypointsVisibilityOfIndoorMap(indoorMapWrapper, false);
                        }


                        //_filterWaypointsByIndoorFloorId(options.currentFloorLevel, indoorFloors, indoorMapWrapper);

                        /** Add or show floor switcher control if nessesary*/
                        //if(isIndoorSwitcherNeeded(this._loadedIndoorMaps)){
                        if (!options.explode) {
                            var initFloorCaption = indoorFloors[options.currentFloorLevel].floor_name;

                            context.enableIndoorFloorSwitcher(initFloorCaption, ()=> {
                                context.increaseIndoorFloor(indoorMapWrapper, options.key, indoorFloors, options);
                            },()=> {
                                context.decreaseIndoorFloor(indoorMapWrapper, options.key, indoorFloors, options);
                            });
                            if (selected) {
                                context.showIndoorFloorSwitcher(true);
                            } else {
                                context.showIndoorFloorSwitcher(false);
                            }

                        } else {
                            context.showIndoorFloorSwitcher(false);
                        }
                    }
                }
            };
            items.push([new DropDownControl(this._mapDiv).checkBox(checkOptions), checkOptions]);
        }

        return items;
    }

    getIndoorMaps(setMapsVisible) {

        var dropDownItems = this.getDropDownItems(this._indoorMapsData, setMapsVisible);
        this._dropDownItems = dropDownItems;
        var dropDownHtmlItems = this.getHtmlDropDownItems(dropDownItems);
        var ddDivOptions = {
            items: dropDownHtmlItems,
            id: this._dropDOwnWrapperId
        };

        this._indoorMapsControl.clearDropDownItems(this._dropDOwnWrapperId);
        this._indoorMapsControl.dropDownOptionsDiv(ddDivOptions);
        
        if(!this._mapsInitialized){
            this._loadedIndoorMaps = this._indoorMapsData;
        }

        /** Select by default if option is set*/
        if (setMapsVisible == true) {
            var item = null;
            for (var k in dropDownItems) {
                if (typeof (item = dropDownItems[k][1]) === "object") {
                    DropDownControl.selectCheckBox(this._mapDiv,item.id, true); //TODO auf dropdowncontrol zugreifen
                    item.action(item, true);
                }
            }
        }

    }


    /**
     * Checks if the center of the visible map is within the provided bounds.
     * @param {Object[]} boundsArray - An array of objects representing bounds. Each object should have lat1, lng1, lat2, and lng2 properties.
     * @returns {boolean} Returns true if the center of the visible map is within the provided bounds, otherwise returns false.
     */
    isCenterInBounds(boundsArray) {

        let aggregateBounds = this.createAggregateBounds(boundsArray);

        // console.log('this._map: ', this._map);
        let visibleBounds = this._map.getBounds();
        if(visibleBounds){
            let visibleBoundsCenter = visibleBounds.getCenter();
            // Check if the center is within the aggregate bounds
            return aggregateBounds.contains(visibleBoundsCenter);
        }
        else{
            return false;
        }
    }

    /**
     * Creates a single LatLngBounds object containing all provided bounds.
     * @param {Object[]} boundsArray - An array of objects representing bounds. Each object should have lat1, lng1, lat2, and lng2 properties.
     * @returns {google.maps.LatLngBounds} Returns a LatLngBounds object containing all provided bounds.
     */
    createAggregateBounds(boundsArray) {
        let aggregateBounds = new google.maps.LatLngBounds();
        boundsArray.forEach(boundsObj => {
            let bounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(boundsObj.lat1, boundsObj.lng1),
                new google.maps.LatLng(boundsObj.lat2, boundsObj.lng2)
            );
            aggregateBounds.union(bounds);
        });
        return aggregateBounds;
    }    
    
   
}
